(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coaching-marquee')) {
    class CoachingMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.coaching-marquee__track');
        if (!this.track) return;
        this.source = this.track.querySelector('.coaching-marquee__group');
        this.build = this.build.bind(this);

        this.ro = new ResizeObserver(() => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(this.build);
        });
        this.ro.observe(this);

        // Re-measure once DM Sans has loaded (text widths change)
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.build);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        cancelAnimationFrame(this.raf);
      }

      build() {
        const groupWidth = this.source.getBoundingClientRect().width;
        if (!groupWidth) return;

        const viewWidth = this.getBoundingClientRect().width;
        // Enough sets to cover the screen + one extra to slide into place
        const needed = Math.max(2, Math.ceil(viewWidth / groupWidth) + 1);
        const groups = this.track.querySelectorAll('.coaching-marquee__group');

        if (groups.length !== needed) {
          groups.forEach((g, i) => { if (i > 0) g.remove(); });
          for (let i = 1; i < needed; i++) {
            const clone = this.source.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
            this.track.appendChild(clone);
          }
        }

        const speed = Math.max(parseFloat(this.dataset.speed) || 40, 1); // px per second
        this.style.setProperty('--coaching-marquee-shift', groupWidth + 'px');
        this.style.setProperty('--coaching-marquee-duration', (groupWidth / speed).toFixed(2) + 's');
        this.style.setProperty('--coaching-marquee-dir', this.dataset.direction === 'right' ? 'reverse' : 'normal');
      }
    }
    customElements.define('coaching-marquee', CoachingMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
